import { FieldErrors, FieldValues, UseFormReturn } from "react-hook-form";

function findFirstErrorPath(
  errors: FieldErrors<FieldValues>,
  parentPath = ""
): string | null {
  for (const [key, value] of Object.entries(errors)) {
    const path = parentPath ? `${parentPath}.${key}` : key;

    if (!value) {
      continue;
    }

    if (typeof value === "object" && "message" in value) {
      return path;
    }

    if (typeof value === "object") {
      const nested = findFirstErrorPath(value as FieldErrors<FieldValues>, path);
      if (nested) {
        return nested;
      }
    }
  }

  return null;
}

export function scrollToFirstInvalidField<TFieldValues extends FieldValues>(
  form: UseFormReturn<TFieldValues>
) {
  const firstErrorPath = findFirstErrorPath(
    form.formState.errors as FieldErrors<FieldValues>
  );

  if (!firstErrorPath) {
    return;
  }

  try {
    form.setFocus(firstErrorPath as any);
  } catch {
    // no-op
  }

  const escapedPath = firstErrorPath.replace(/\./g, "\\.");
  const selector =
    `[name=\"${firstErrorPath}\"], [name=\"${escapedPath}\"], [id=\"${firstErrorPath}\"]`;

  const element = document.querySelector(selector) as HTMLElement | null;

  if (element) {
    element.scrollIntoView({ behavior: "smooth", block: "center" });
    element.focus?.();
  }
}
